import { colorsPalettes } from "@similarweb/styles";

export const TOTAL_SCORE_CHANGE_VALUE = 0.01;
const MAX_VERSUS_ICON_COUNT = 4;
const VERSES_ICON_SIZE = 24;

const colors = [
    colorsPalettes.midnight[300],
    colorsPalettes.orange[400],
    colorsPalettes.mint[400],
    colorsPalettes.solutions.SALES,
    colorsPalettes.solutions.DIGITAL_RESEARCH,
    colorsPalettes.purple[300],
    colorsPalettes.teal[300],
];

const otherColor = colorsPalettes.carbon[100];
